var exports = {
  "container": "x24da60e8--fa1ed6--container",
  "desktop": "x24da60e8--fa1ed6--desktop",
  "description": "x24da60e8--fa1ed6--description",
  "phone": "x24da60e8--fa1ed6--phone",
  "tablet": "x24da60e8--fa1ed6--tablet",
  "controls": "x24da60e8--fa1ed6--controls",
};

module.exports = exports;
